import React from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({ message, action, testid }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/70 bg-card/40 px-6 py-14 text-center"
      data-testid={testid || 'empty-state'}
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gold/10 ring-1 ring-gold/20">
        <Inbox className="h-6 w-6 text-gold" strokeWidth={1.6} />
      </div>
      <p className="mt-4 text-sm text-muted-foreground max-w-xs">{message}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
